import React, { Component } from 'react';
import classnames from 'classnames';
import { CategoryTypes } from '../../constants/category/DragAndDropTypes';
import { connect } from 'react-redux'
import { DropTarget } from 'react-dnd'
import { moveCategory } from '../../actions/category'

@connect(state => ({
}), dispatch => ({
    handleMoveCategory: (category, to, placement) => {
        dispatch(moveCategory(category, to, placement))
    },
    dispatch
}))
@DropTarget(CategoryTypes.NODE, {
    canDrop(props, monitor) {

        const dragging = monitor.getItem();

        const draggingItem = dragging.category;
        const draggingItemHasChild = dragging.hasChild;
        const hoverItem = props.category;
        const hoverItemsParent = props.parent;
        const addChild = props.addChild;

        // 현재 드래그 하는 아이템이 옮기려는 아이템과 동일한 경우
        if (draggingItem === hoverItem) return false;

        // 현재 드래그 하는 아이템이 옮기려는 아이템의 부모와 동일한 경우
        // 드래그 하는 아이템의 서브로 넣으려고 하는 경우
        if (draggingItem === hoverItemsParent) return false;


        // 현재 이동하려는 액션이 하위 노드에 추가하는 액션인데
        // 드래그 하는 아이템이 자식 노드를 가지고 있는 경우
        if (addChild && draggingItemHasChild) return false;

        // 현재 hover 된 아이템이 depth 가 1 이상인 자식 노드인데.
        // 드래그 하려는 아이템이 자식 노드를 가지고 있는 경우
        if (draggingItemHasChild && hoverItem.depth > 1) return false;


        if(draggingItem.depth === 2 && hoverItem.depth === 2 && addChild) return false;


        return true;
    },
    drop(props, monitor, component) {
        if(this.canDrop(props, monitor)) {

            const category = monitor.getItem().category;
            const toId = props.category.id;
            const placement = props.placement;

            props.handleMoveCategory(category, toId, placement);
        }
    },
}, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
    dragging : monitor.getItem()
}))
class GuideLine extends Component {
    constructor(props) {
        super(props);

        this.canDrop = this.canDrop.bind(this);
    }

    shouldComponentUpdate(nextProps) {
        if(this.props.dragging !== nextProps.dragging)
            return true;
        else if(this.props.isOver !== nextProps.isOver)
            return true;
        return false;
    }

    canDrop(){

        const { dragging } = this.props;

        if(dragging === null) return false;

        const draggingItem = dragging.category;
        const draggingItemHasChild = dragging.hasChild;
        const hoverItem = this.props.category;
        const hoverItemsParent = this.props.parent;
        const addChild = this.props.addChild;

        // 현재 드래그 하는 아이템이 옮기려는 아이템과 동일한 경우
        if (draggingItem === hoverItem) return false;

        // 현재 드래그 하는 아이템이 옮기려는 아이템의 부모와 동일한 경우
        // 드래그 하는 아이템의 서브로 넣으려고 하는 경우
        if (draggingItem === hoverItemsParent) return false;


        // 현재 이동하려는 액션이 하위 노드에 추가하는 액션인데
        // 드래그 하는 아이템이 자식 노드를 가지고 있는 경우
        if (addChild && draggingItemHasChild) return false;

        // 현재 hover 된 아이템이 depth 가 1 이상인 자식 노드인데.
        // 드래그 하려는 아이템이 자식 노드를 가지고 있는 경우
        if (draggingItemHasChild && hoverItem.depth > 1) return false;


        if(draggingItem.depth === 2 && hoverItem.depth === 2 && addChild) return false;

        return true;

    }

    render() {

        const {connectDropTarget, isOver, dragging, addChild} = this.props;

        if (dragging === null) return null;

        let canDrop = this.canDrop();

        if(!canDrop) return null;

        return connectDropTarget(
            <div className={classnames("add_line", {show:(isOver), "add_sibling" : !addChild, "add_child" : addChild})}/>
        );
    }
}

export default GuideLine;
